'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This pubNub message occurs when a contact is dissacosiated from a thread in the inbox
 * In order to correctly handle this we will need to update the utk in the visitor-ui
 * ***NOTE***
 * Since the visitor may not be on the page anymore, so this is more of a best effort
 *
 * @param newMessagesUtk - string
 * @param newVid - number
 */
exports.default = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.CONTACT_ASSOCIATION), _defineProperty(_Record, 'newMessagesUtk', null), _defineProperty(_Record, 'newVid', null), _Record), 'ContactAssociationMetadata');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/contact-association-metadata/records/ContactAssociationMetadata.js
// module id = 737
// module chunks = 2 3